module.exports = __webpack_public_path__ + "images/icons_v2/juul-mark-baseline-outlined-82bd2041.svg";